import { PartnerImportPage } from "@/features/partner/pages/PartnerImport";

const PartnerImport = () => {
  return <PartnerImportPage />;
};

export default PartnerImport;
